export default "__VITE_ASSET__60269be3__"